import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-sm p-6 md:p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Terms of Service
            </h1>
            <p className="text-gray-600">
              Merkado Ekspress - Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                1. Acceptance of Terms
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>
                  By accessing and using the Merkado Ekspress mobile application and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                2. Description of Service
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>
                  Merkado Ekspress is a cooperative marketplace platform that provides:
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Online marketplace for cooperative members</li>
                  <li>Delivery and logistics services</li>
                  <li>Payment processing and financial services</li>
                  <li>Membership management and cooperative governance</li>
                  <li>Order management and tracking</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                3. User Accounts and Registration
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>To access certain features of the service, you must register for an account. You agree to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Provide accurate, current, and complete information</li>
                  <li>Maintain and update your account information</li>
                  <li>Keep your password secure and confidential</li>
                  <li>Accept responsibility for all activities under your account</li>
                  <li>Notify us immediately of any unauthorized use</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                4. Cooperative Membership
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>Membership in the PPAC Cooperative is subject to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Approval of membership application</li>
                  <li>Payment of required share capital (₱4,000)</li>
                  <li>Payment of entrance fee</li>
                  <li>Compliance with cooperative bylaws and regulations</li>
                  <li>Active participation in cooperative activities</li>
                </ul>
                <p>Membership benefits include access to the marketplace, voting rights, and profit sharing according to cooperative policies.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                5. Marketplace Rules
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>When using the marketplace, you agree to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>List only legitimate products and services</li>
                  <li>Provide accurate product descriptions and pricing</li>
                  <li>Honor all commitments and agreements</li>
                  <li>Maintain high standards of customer service</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Not engage in fraudulent or deceptive practices</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                6. Payment Terms
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>Payment processing is handled through secure third-party providers. You agree to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Provide valid payment information</li>
                  <li>Pay all fees and charges in full and on time</li>
                  <li>Accept responsibility for payment disputes</li>
                  <li>Comply with refund and cancellation policies</li>
                  <li>Pay applicable taxes and fees</li>
                </ul>
                <p>All transactions are final unless otherwise specified in our refund policy.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                7. Delivery and Logistics
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>Delivery services are subject to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Availability in your area</li>
                  <li>Delivery fees and timeframes</li>
                  <li>Weather and traffic conditions</li>
                  <li>Proper packaging and handling requirements</li>
                  <li>Signature requirements for certain items</li>
                </ul>
                <p>We are not responsible for delays beyond our control, including weather, traffic, or recipient unavailability.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                8. Prohibited Activities
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>You agree not to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Use the service for illegal purposes</li>
                  <li>Violate any applicable laws or regulations</li>
                  <li>Infringe on intellectual property rights</li>
                  <li>Harass, abuse, or harm other users</li>
                  <li>Attempt to gain unauthorized access to systems</li>
                  <li>Interfere with service operation or security</li>
                  <li>Use automated systems to access the service</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                9. Intellectual Property
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>The service and its content are protected by copyright, trademark, and other intellectual property laws. You may not:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Copy, modify, or distribute our content</li>
                  <li>Use our trademarks without permission</li>
                  <li>Reverse engineer our software</li>
                  <li>Remove copyright or proprietary notices</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                10. Limitation of Liability
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>To the maximum extent permitted by law, PPAC Cooperative and Merkado Ekspress shall not be liable for:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Indirect, incidental, or consequential damages</li>
                  <li>Loss of profits, data, or business opportunities</li>
                  <li>Damages resulting from third-party actions</li>
                  <li>Service interruptions or technical issues</li>
                  <li>User disputes or disagreements</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                11. Termination
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>We may terminate or suspend your account and access to the service at any time, with or without cause, including:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Violation of these terms</li>
                  <li>Fraudulent or illegal activity</li>
                  <li>Non-payment of fees</li>
                  <li>Inactivity for extended periods</li>
                </ul>
                <p>Upon termination, your right to use the service ceases immediately.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                12. Changes to Terms
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the service constitutes acceptance of the modified terms.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                13. Governing Law
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>These terms are governed by the laws of the Philippines. Any disputes shall be resolved in the courts of the Philippines.</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                14. Contact Information
              </h2>
              <div className="space-y-3 text-gray-700">
                <p>If you have questions about these Terms of Service, please contact us:</p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Email:</strong> legal@merkadoekspress.com</p>
                  <p><strong>Phone:</strong> +63 950-468-6668</p>
                  <p><strong>Address:</strong> PPAC Cooperative, Philippines</p>
                </div>
              </div>
            </section>
          </div>

          <div className="text-center mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/"
              className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
